var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{staticStyle:{"padding":"10px 16px"},attrs:{"round":"","type":"warning","size":"medium","disabled":_vm._item.status === 'release'},on:{"click":_vm.launcher}},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.renewal"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }